import $ from "jquery"

export const onUpdateUserData = (data) => {
    $(document).trigger('editUserPanel_updateUserData', [data])
}

export const onDeleteUser = (data) => {
    $(document).trigger('editUserPanel_deleteUserSucceeded', [data])
}

export const onNoSuchUserException = (userId) => {
    $(document).trigger('editUserPanel_noSuchUserException', [userId])
}



// WEBPACK FOOTER //
// ./web/js/panels/user/editPanel/syncCallbacks.js